import { Moment } from 'moment';

export class Address{
    constructor(obj?: Partial<Address>) {
        Object.assign(this, obj);
    }
    id : Number;
    addressLine1 ?: String;
    addressLine2 ?: String;
    city ?: String;
    locality ?: String;
    countryCode ?: {};
    doorNo ?: String;
    fromDate ?: Moment;
    postCode ?: String;
    stateProvinceCode ?: String;
    stateProvinceName ?: String;
    streetNo ?: String;
    toDate ?: Moment;
    type ?: {
        id ?: Number;
    }
       
}

// Addedd FirmFormAddres
export class FirmAddress{
    constructor(obj?: Partial<Address>) {
        Object.assign(this, obj);
    }
    id : Number;
    addressLine1 ?: String;
    addressLine2 ?: String;
    city ?: String;
    countryCode ?: {
        countryCode?: String;
    };
    doorNo ?: String;
    fromDate ?: Moment;
    postCode ?: String;
    stateProvinceCode ?: String;
    stateProvinceName ?: String;
    streetNo ?: String;
    toDate ?: Moment;
    type ?: {
        id ?: Number;
    }
       
}